import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { selectCurrentAppAlias } from '@ispm/navigation/store/navigation.selector';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class SelectorUrlBuilderService {

  constructor(private store$: Store<IgenomicsState>) {
  }

  public getSelectorUrl(selectorData: any, type: string = '') {
    const selectorType = !!type ? type : selectorData.type;
    let appName = '';
    this.getAppNameAliasFromStore().subscribe((data) => {
      appName = data !== '' ? '?appname=' + data : '';
    });
    return `/curation/${selectorData.code}/${selectorData.workflowRequestId}/${selectorData.revisionId}/${selectorType}${appName}`;
  }

  private getAppNameAliasFromStore(): Observable<string> {
    return this.store$.select(selectCurrentAppAlias).pipe(
      take(1),
      map((data) => {
        return !!data ? data : '';
      })
    );
  }
}
